import { render } from "./SafetyTaskTemplateList.vue?vue&type=template&id=724dcdab&scoped=true"
import script from "./SafetyTaskTemplateList.vue?vue&type=script&lang=js"
export * from "./SafetyTaskTemplateList.vue?vue&type=script&lang=js"

import "./SafetyTaskTemplateList.vue?vue&type=style&index=0&id=724dcdab&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-724dcdab"],['__file',"src/views/h5/luqiao/attendance/task/SafetyTaskTemplateList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "724dcdab"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('724dcdab', __exports__)) {
    api.reload('724dcdab', __exports__)
  }
  
  module.hot.accept("./SafetyTaskTemplateList.vue?vue&type=template&id=724dcdab&scoped=true", () => {
    api.rerender('724dcdab', render)
  })

}


export default __exports__